const Backdrops = () => null;

export const GlowOrbs = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    <div className="absolute -left-40 top-1/4 h-[480px] w-[480px] rounded-full bg-arc/15 blur-[140px]" />
    <div className="absolute -right-40 bottom-0 h-[420px] w-[420px] rounded-full bg-epurple/10 blur-[140px]" />
  </div>
);

export const Particles = ({ count = 24 }) => {
  const dots = Array.from({ length: count });
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {dots.map((_, i) => {
        const left = (i * 41) % 100;
        const top = (i * 67) % 100;
        const size = (i % 3) + 1;
        const delay = (i % 7) * 0.9;
        return (
          <span
            key={i}
            className="absolute animate-floaty rounded-full bg-ice/50"
            style={{
              left: `${left}%`,
              top: `${top}%`,
              width: size,
              height: size,
              animationDelay: `${delay}s`,
              opacity: 0.25 + (i % 4) * 0.12,
              boxShadow: "0 0 8px rgba(125,220,255,0.8)",
            }}
          />
        );
      })}
    </div>
  );
};

export default Backdrops;
